import { modules } from "../../components/modules";
import { oKBehaviours, SECTIONS } from "../config";
import { FLOW_MESSAGES } from "../../components/shared/components/flowMessages/components";
import { MILESTONES } from "../../components/shared/sharedKernel/EventCatcher/config";
import { EVENT_TYPES } from "nemuru-components";
import {
  assetTypes,
  ONBOARDING_PARTICIPANT_ROLES,
} from "../../components/shared/config";
import { LoanStatus } from "@nemuru-eng/js-api-client";

export const flowCaixabankKnownCustomer = {
  name: "CaixaBank Known Customer",
  modules: [
    {
      id: modules.CARD.id,
      section: {
        name: SECTIONS.IDENTIFICATION,
        progressPercentage: "15%",
      },
      onAppResume: {
        conditionsToBeInitialModuleInFlow: (processState) =>
          processState.loan?.asset_reference[0].type === assetTypes.CARD &&
          !processState.loan?.borrower_user_details_on_origination,
        welcomeMessageId: FLOW_MESSAGES.WELCOME_BACK_WITH_PROGRESS.id,
      },
    },
    {
      id: modules.DOWNPAYMENT_CALCULATOR.id,
      onKO: {
        id: modules.DOWNPAYMENT_CALCULATOR.id,
        onOK: oKBehaviours.NEXT_FLOW_ITEM,
      },
      section: {
        name: SECTIONS.IDENTIFICATION,
        progressPercentage: "25%",
      },
      onAppResume: {
        conditionsToBeInitialModuleInFlow: (processState) =>
          processState.loan?.asset_reference[0].type === assetTypes.AUTO &&
          !processState.loan?.borrower_user_details_on_origination &&
          processState.participant.role ===
            ONBOARDING_PARTICIPANT_ROLES.BORROWER,
        welcomeMessageId: FLOW_MESSAGES.WELCOME_BACK_WITH_PROGRESS.id,
      },
    },
    {
      id: modules.FULL_KYC_AUTOMATIC.id,
      props: {
        disableMaritalRegime: true,
        disableKycManual: true,
        disableOthers: true,
      },
      onKO: {
        id: modules.KYC_MANUAL.id,
        onOK: oKBehaviours.NEXT_FLOW_ITEM,
        props: { disableMaritalRegime: true, disableOthers: true },
      },
      section: {
        name: SECTIONS.IDENTIFICATION,
        progressPercentage: "50%",
      },
      onAppResume: {
        conditionsToBeInitialModuleInFlow: (processState) =>
          !processState.loan?.borrower_user_details_on_origination ||
          !processState.caixabank?.isDocumentNumberValid === false,
        welcomeMessageId: FLOW_MESSAGES.WELCOME_BACK_WITH_PROGRESS.id,
      },
    },
    {
      id: modules.KYC_DOCUMENT_NUMBER_VALIDATION.id,
      section: {
        name: SECTIONS.IDENTIFICATION,
        progressPercentage: "100%",
      },
      onOK: {
        //   showOKMessage: {
        //     id: FLOW_MESSAGES.SECTION_IDENTIFICATION_END.id,
        //     fadeIn: true,
        //   },
        sendEvents: [
          {
            name: MILESTONES.KYC_COMPLETED,
            type: EVENT_TYPES.milestoneCompleted,
          },
        ],
      },
      onAppResume: {
        conditionsToBeInitialModuleInFlow: (processState) =>
          processState.loan?.borrower_user_details_on_origination
            ?.familiar_situation_details &&
          !processState.loan?.borrower_bank_reader_id &&
          !processState.loan?.declared_income_id,
        welcomeMessageId: FLOW_MESSAGES.WELCOME_BACK_WITH_PROGRESS.id,
      },
    },
    {
      id: modules.DECLARED_INCOME.id,
      props: {
        disableNetIncomeType: true,
        forceCaixaBankIBAN: false,
        disableOthers: true,
      },
      section: {
        name: SECTIONS.FINANCES,
        progressPercentage: "50%",
      },
      onAppResume: {
        conditionsToBeInitialModuleInFlow: (processState) =>
          processState.loan?.borrower_user_details_on_origination
            ?.familiar_situation_details &&
          !processState.loan?.declared_income_id,
        welcomeMessageId: FLOW_MESSAGES.WELCOME_BACK_WITH_PROGRESS.id,
      },
    },
    {
      id: modules.PROFESSIONAL_DATA.id,
      props: { disableOthers: true },
      onKO: null,
      section: {
        name: SECTIONS.FINANCES,
        progressPercentage: "100%",
      },
      onOK: {
        sendEvents: [
          {
            name: MILESTONES.PROFESSIONAL_DETAILS_COMPLETED,
            type: EVENT_TYPES.milestoneCompleted,
          },
        ],
      },
      onAppResume: {
        conditionsToBeInitialModuleInFlow: (processState) =>
          !processState.loan?.borrower_user_details_on_origination
            ?.professional_details,
        welcomeMessageId: FLOW_MESSAGES.WELCOME_BACK_WITH_PROGRESS.id,
      },
    },
    {
      id: modules.SUMMARY_AND_ADJUST.id,
      onKO: null,
      section: {
        name: SECTIONS.SUMMARY,
        progressPercentage: "33%",
      },
      onOK: {
        sendEvents: [
          {
            name: MILESTONES.APPLICATION_CREATED_IN_LENDER,
            type: EVENT_TYPES.milestoneCompleted,
          },
        ],
      },
      onAppResume: {
        conditionsToBeInitialModuleInFlow: (processState) =>
          processState.loan?.loan_application_ids?.length === 0 ||
          !processState.loan?.loan_application_ids,
        welcomeMessageId: FLOW_MESSAGES.WELCOME_BACK_WITH_PROGRESS.id,
      },
    },
    {
      id: modules.APPLICATION_INFO.id,
      props: {
        disableDocumentation: false,
      },
      onKO: null,
      section: {
        name: SECTIONS.SUMMARY,
        progressPercentage: "66%",
      },
      onAppResume: {
        conditionsToBeInitialModuleInFlow: (processState) =>
          processState.loan?.loan_application_ids &&
          processState.loan?.loan_application_ids?.length > 0,
        welcomeMessageId: FLOW_MESSAGES.WELCOME_BACK.id,
      },
    },
    {
      id: modules.DOCUMENTATION.id,
      onKO: null,
      // onOK: {  // TODO review how to show message only on true OK, not in skipped
      //   showOKMessage: {
      //     id: FLOW_MESSAGES.DOCUMENTATION_UPLOADED.id,
      //     fadeIn: true,
      //   },
      // },
      section: {
        name: SECTIONS.SUMMARY,
        progressPercentage: "80%",
      },
    },
    {
      id: modules.OPTINS_AND_SIGNATURE.id,
      onKO: null,
      section: {
        name: SECTIONS.SUMMARY,
        progressPercentage: "100%",
      },
    },
    {
      id: modules.APPLICATION_INFO.id,
      props: {
        disableDocumentation: true,
      },
      onKO: null,
      section: {
        name: null,
      },
    },
    {
      id: modules.DOCUMENTATION.id,
      onKO: null,
      section: {
        name: SECTIONS.SUMMARY,
        progressPercentage: "80%",
      },
    },
    {
      id: modules.VALIDATION_LINK.id,
      onKO: null,
      section: {
        name: SECTIONS.SUMMARY,
        progressPercentage: "100%",
      },
      onAppResume: {
        conditionsToBeInitialModuleInFlow: (processState) =>
          processState.loan.status === LoanStatus.STATUS_CONTRACT_SIGNED &&
          processState.loan.asset_reference[0].type === assetTypes.CARD,
      },
    },
  ],
};
